export type SceneInventoryLabelVisibilityState = {
  actuator: boolean;
  mesh: boolean;
  visual: boolean;
  collision: boolean;
  inertial: boolean;
  camera: boolean;
};

export const SCENE_INVENTORY_LABEL_VISIBILITY_EVENT = "scene-inventory-label-visibility-changed";

export const DEFAULT_SCENE_INVENTORY_LABEL_VISIBILITY_STATE: SceneInventoryLabelVisibilityState = {
  actuator: false,
  mesh: false,
  visual: false,
  collision: false,
  inertial: false,
  camera: false,
};

let currentSceneInventoryLabelVisibilityState: SceneInventoryLabelVisibilityState = {
  ...DEFAULT_SCENE_INVENTORY_LABEL_VISIBILITY_STATE,
};

export function getSceneInventoryLabelVisibilityState(): SceneInventoryLabelVisibilityState {
  return { ...currentSceneInventoryLabelVisibilityState };
}

export function setSceneInventoryLabelVisibilityState(
  patch: Partial<SceneInventoryLabelVisibilityState>
): SceneInventoryLabelVisibilityState {
  currentSceneInventoryLabelVisibilityState = {
    ...currentSceneInventoryLabelVisibilityState,
    ...patch,
  };
  dispatchSceneInventoryLabelVisibilityState(currentSceneInventoryLabelVisibilityState);
  return getSceneInventoryLabelVisibilityState();
}

export function dispatchSceneInventoryLabelVisibilityState(
  state: SceneInventoryLabelVisibilityState
): void {
  currentSceneInventoryLabelVisibilityState = { ...state };
  if (typeof window === "undefined") return;
  window.dispatchEvent(
    new CustomEvent(SCENE_INVENTORY_LABEL_VISIBILITY_EVENT, {
      detail: { ...state },
    })
  );
}
